import React from 'react'
import { useLoaderData } from 'react-router-dom'
import Hero from './modules/Hero/Hero'
import PageTransition from './templateParts/PageTransition'
import AboutUs from './modules/AboutUs/AboutUs'
import Services from './modules/ServicesComponent/Services'
import Contact from './modules/Contact/Contact'
import ContactForm from './modules/ContactForm/ContactForm'
import AdvisoryServices from './modules/AdvisoryServices/AdvisoryServices'
import MAService from './modules/MAService/MAService'
import PrivacyPolicy from './modules/PrivacyPolicy/PrivacyPolicy'
import Team from './modules/Team/Team'
import Posts from './modules/Posts/Posts'
import Transactions from './modules/Transactions/Transactions'
import MarketInsights from './modules/MarketInsights/MarketInsights'
import Unsubscribe from './modules/Unsubscribe/Unsubscribe'
// import for new component DO NOT DELETE

export default function Page() {
  const data = useLoaderData()

  const renderComponents = () => {
    if (!data) return null
    const componentList = data.map((x, i) => {
      switch (x.acf_fc_layout) {
        case 'Hero':
          return <Hero key={i} data={x} />
        case 'AboutUs':
          return <AboutUs key={i} data={x} />
        case 'ServicesComponent':
          return <Services key={i} data={x} />
        case 'Contact':
          return <Contact key={i} data={x} />
        case 'ContactForm':
          return <ContactForm key={i} data={x} />
        case 'AdvisoryServices':
          return <AdvisoryServices key={i} data={x} />
        case 'MAService':
          return <MAService key={i} data={x} />
        case 'PrivacyPolicy':
          return <PrivacyPolicy key={i} data={x} />
        case 'Team':
          return <Team key={i} data={x} />
        case 'Posts':
          return <Posts key={i} data={x} />
        case 'Transactions':
          return <Transactions key={i} data={x} />
        case 'MarketInsights':
          return <MarketInsights key={i} data={x} />
        case 'Unsubscribe':
          return <Unsubscribe key={i} data={x} />
        default:
          return null
      }
    })
    return componentList
  }

  return <PageTransition>{renderComponents()}</PageTransition>
}
